import type { ConstructorPlan } from '../constructorTypes'

function readAnalyticsNumber(metadata: Record<string, unknown> | undefined, key: string): number | null {
  const value = metadata?.[key]
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

export function PlanAnalyticsPanel({ plan }: { plan: ConstructorPlan }) {
  const analytics = plan.analytics ?? {}
  const metadata = analytics.metadata ?? {}
  const viewCount = analytics.view_count ?? 0
  const lastReadSeconds = readAnalyticsNumber(metadata, 'last_read_time_seconds')
  const scrollDepth = readAnalyticsNumber(metadata, 'last_scroll_depth_percent')
  const lastClick = typeof metadata.last_click_target === 'string' ? metadata.last_click_target : null
  const events = analytics.events ?? []

  return (
    <div className="rounded-xl border border-violet-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h3 className="text-sm font-semibold text-slate-800">Аналитика и follow-up</h3>
          <p className="mt-1 text-[11px] text-slate-500">Просмотры, скролл, время чтения и контактные клики пациента.</p>
        </div>
        <span className="rounded-full bg-violet-50 px-2 py-0.5 text-[11px] font-semibold text-violet-700">{viewCount} просмотров</span>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
        <div className="rounded-lg bg-slate-50 p-2">
          <div className="text-[10px] uppercase tracking-wide text-slate-400">Последний просмотр</div>
          <div className="mt-1 font-semibold text-slate-700">
            {analytics.last_viewed_at ? new Date(analytics.last_viewed_at).toLocaleString('ru-RU') : 'пока нет'}
          </div>
        </div>
        <div className="rounded-lg bg-slate-50 p-2">
          <div className="text-[10px] uppercase tracking-wide text-slate-400">Читал</div>
          <div className="mt-1 font-semibold text-slate-700">{lastReadSeconds != null ? `${lastReadSeconds} сек.` : '—'}</div>
        </div>
        <div className="rounded-lg bg-slate-50 p-2">
          <div className="text-[10px] uppercase tracking-wide text-slate-400">Доскроллил</div>
          <div className="mt-1 font-semibold text-slate-700">{scrollDepth != null ? `${scrollDepth}%` : '—'}</div>
        </div>
        <div className="rounded-lg bg-slate-50 p-2">
          <div className="text-[10px] uppercase tracking-wide text-slate-400">Последний клик</div>
          <div className="mt-1 truncate font-semibold text-slate-700">{lastClick ?? '—'}</div>
        </div>
      </div>
      <div className="mt-3 rounded-lg border border-violet-100 bg-violet-50 px-3 py-2 text-[11px] text-violet-800">
        Умный follow-up: если есть просмотр, но нет клика/обращения 24 часа, координатору нужна задача "позвонить", пациенту — мягкое напоминание в Telegram/MAX.
      </div>
      {events.length > 0 ? (
        <div className="mt-3 max-h-40 space-y-1 overflow-y-auto pr-1 text-[11px]">
          {events.slice(0, 8).map((event, index) => (
            <div key={`${event.event}-${event.created_at}-${index}`} className="flex justify-between gap-2 rounded border border-slate-100 px-2 py-1">
              <span className="font-medium text-slate-700">{event.event}</span>
              <span className="text-slate-400">{event.created_at ? new Date(event.created_at).toLocaleString('ru-RU') : ''}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}
